export default "__VITE_ASSET__DTfKujFL__"